"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PreviewDoughnut = _interopRequireDefault(require("./PreviewDoughnut.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var PreviewDoughnut = /*#__PURE__*/function (_React$Component) {
  function PreviewDoughnut(props) {
    var _this;
    _classCallCheck(this, PreviewDoughnut);
    _this = _callSuper(this, PreviewDoughnut, [props]);
    _this.state = {};
    return _this;
  }
  _inherits(PreviewDoughnut, _React$Component);
  return _createClass(PreviewDoughnut, [{
    key: "render",
    value: function render() {
      var halfsize = this.props.size * 0.5;
      var radius = halfsize - this.props.strokewidth * 0.5;
      var circumference = 2 * Math.PI * radius;
      var strokeval = this.props.value * circumference / 100;
      var dashval = "".concat(strokeval, " ").concat(circumference);
      var textDYValue = halfsize - halfsize * 0.65 * -0.25;
      var trackstyle = {
        strokeWidth: this.props.strokewidth
      };
      var indicatorstyle = {
        strokeWidth: this.props.strokewidth,
        strokeDasharray: dashval
      };
      var rotateval = "rotate(-90 ".concat(halfsize, ",").concat(halfsize, ")");
      return /*#__PURE__*/_react["default"].createElement(_PreviewDoughnut["default"], {
        isDefault: this.props.isDefault,
        isActive: this.props.isActive,
        colorScheme: this.props.color,
        DoughnutSize: halfsize,
        className: "preview-wrapper"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        width: this.props.size,
        height: this.props.size,
        className: "DoughnutChart"
      }, /*#__PURE__*/_react["default"].createElement("circle", {
        r: radius,
        cx: halfsize,
        cy: halfsize,
        transform: rotateval,
        style: trackstyle,
        className: "DoughnutChart-track"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        r: radius,
        cx: halfsize,
        cy: halfsize,
        transform: rotateval,
        style: indicatorstyle,
        className: "DoughnutChart-indicator"
      }), /*#__PURE__*/_react["default"].createElement("text", {
        className: "DoughnutChart-text",
        x: halfsize,
        dy: textDYValue,
        textAnchor: "middle",
        dominantBaseline: "reset-size"
      }, /*#__PURE__*/_react["default"].createElement("tspan", {
        className: "DoughnutChart-text-val"
      }, this.props.value, "%"))));
    }
  }]);
}(_react["default"].Component);
PreviewDoughnut.propTypes = {
  /** Value the chart should show */
  value: _propTypes["default"].number,
  /** Diameter of chart */
  size: _propTypes["default"].number,
  /** Width of chart line */
  strokewidth: _propTypes["default"].number,
  /** Color of chart indicator. String 'category[*]' - [*] = 0 to 10. e.g (category0). */
  color: _propTypes["default"].string,
  /** State of the component */
  isActive: _propTypes["default"].bool,
  /** Default state of the component */
  isDefault: _propTypes["default"].bool
};
PreviewDoughnut.defaultProps = {
  value: 0,
  size: 116,
  strokewidth: 8,
  color: '',
  isActive: false,
  isDefault: false
};
var _default = exports["default"] = PreviewDoughnut;